<template>
  <populate-form
    formTitle="供應商資訊"
    fkey="mi01"
    ref="merchantInfoForm"
    populateOptionVar="merchantFormItems"
    formDataObjVar="FocusedMerchant"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
</template>

<script>

export default {
  name: 'MerchantInfo',
  components: {
    
  },
  props: {
    'cbSave':{
      type:Function,
      default: function () {
        return
      }
    },
    'cbCancel':{
      type:Function,
      default: function () {
        return
      }
    },
    'parentVue':Object,
  },
  data: function () {
    return {
      merchantFormItems:[
        {
          'componentType':'span',
          'akey':'span1',
          'col':2,
          'placeholder':'廠商代號',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'supplier_id',
          'col':4,
          'placeholder':'供應商名稱',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':2,
          'placeholder':'供應商名稱',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'merchant_name',
          'col':4,
          'placeholder':'供應商名稱',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span3',
          'col':2,
          'placeholder':'供應商名稱',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'merchant_description',
          'col':10,
          'placeholder':'供應商全稱',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span4',
          'col':2,
          'placeholder':'供應商地址',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'supplier_address',
          'col':10,
          'placeholder':'供應商地址',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span5',
          'col':2,
          'placeholder':'統編',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'identity_id',
          'col':4,
          'placeholder':'統編',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span6',
          'col':2,
          'placeholder':'發票/收據',
          'title':'',
        },
        {
          'componentType':'b-form-select',
          'dataOptions':[{'value':'invoice','text':'發票'},{'value':'receipt','text':'收據'},{'value':null,'text':'未定義'}],
          'akey':'invoice_type',
          'col':4,
          'placeholder':'發票/收據',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span7',
          'col':12,
          'placeholder':'聯絡人資訊',
          'title':'',
        },
        {
          'componentType':'span',
          'akey':'span8',
          'col':2,
          'placeholder':'負責人',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_name',
          'col':4,
          'placeholder':'負責人',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span9',
          'col':2,
          'placeholder':'email',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_email',
          'col':4,
          'placeholder':'email',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span10',
          'col':2,
          'placeholder':'電話',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_tel',
          'col':4,
          'placeholder':'電話',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span11',
          'col':2,
          'placeholder':'行動電話',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_m_tel',
          'col':4,
          'placeholder':'聯絡行動電話',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span12',
          'col':2,
          'placeholder':'備註',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_memo',
          'col':10,
          'placeholder':'備註',
          'disabled':true,
        },
        {
          'componentType':'b-button',
          'akey':'button_cancel',
          'col':6,
          'placeholder':'返回',
          'title':'',
          'execCallback':this.cbCancel
        },
        {
          'componentType':'b-button',
          'akey':'button_save',
          'col':6,
          'placeholder':'更新',
          'title':'',
          'execCallback':this.saveMerchant
        },
      ],
    }
  },
  methods: {
    saveMerchant () {
      // 暫時不提供當作沒發生= =
      this.$bus.fnShowInfo('目前不提供在此修改供應商')
      this.cbCancel()
    },
  },
  computed: {
    parentRef () {
      if (this.parentVue) {
        return this.parentVue
      }
      else {
        return this
      }
    },
    FocusedMerchant () {
      return this.parentRef['FocusedMerchant']?this.parentRef['FocusedMerchant']:{}
    },
  },
  created() {
    
  },
  watch: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
